import {JsonProperty} from "@hyperloris/tyson";

export class ApsIdFormat {

  @JsonProperty()
  length: number;
  @JsonProperty()
  direction: number;

  public static format(apsIdFormat:ApsIdFormat, ref: string): string {
    if (!ref || ref.length <= apsIdFormat.length) {
      return ref;
    } else if (apsIdFormat.direction <= 0) {
      return ref.substring(0, apsIdFormat.length);
    } else {
      return ref.substring(ref.length - apsIdFormat.length);
    }
  }
}
